// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2Px22","forms":"Login_forms__26J90"};